import { gql } from '@apollo/client';

export const GET_DASHBOARD_QUERY = gql`
  query GetDashboard($year: Int) {
    getDashboard(year: $year) {
      startYear {
        label
        value
      }
      midYear {
        label
        value
      }
      endYear {
        label
        value
      }
    }
  }
`;

export type GetDashboardVariables = {
  year?: number;
};

type DashboardDataType = {
  label: string;
  value: number;
};

export type GetDashboardResponse = {
  getDashboard: {
    startYear: DashboardDataType[];
    midYear: DashboardDataType[];
    endYear: DashboardDataType[];
  };
};
